<template>
  <!-- A stat's history over the period, in the history grey, with the current
       bucket in the accent and a dot on its end. Decoration for the number
       beside it: the tile's delta says what it means. -->
  <svg
    class="spark"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    aria-hidden="true"
    focusable="false"
  >
    <path
      v-if="history"
      :d="history"
      fill="none"
      :stroke="historyColor"
      stroke-width="2"
      stroke-linejoin="round"
      stroke-linecap="round"
    />
    <path
      v-if="current"
      :d="current"
      fill="none"
      :stroke="color"
      stroke-width="2"
      stroke-linejoin="round"
      stroke-linecap="round"
    />
    <circle v-if="last" :cx="last.x" :cy="last.y" r="3" :fill="color" class="spark__dot" />
  </svg>
</template>
<script>
import { CHART_COLORS } from '@/utils/dashboard';

// Room for the end dot and its ring.
const PAD = 4;

const round1 = (value) => Math.round(value * 10) / 10;

export default {
  name: 'Sparkline',
  props: {
    values: { type: Array, default: () => [] },
    color: { type: String, default: CHART_COLORS.accent },
    historyColor: { type: String, default: CHART_COLORS.history },
    width: { type: Number, default: 96 },
    height: { type: Number, default: 32 },
  },
  computed: {
    points() {
      const values = this.values.map((value) => Math.max(0, Number(value) || 0));
      if (!values.length) return [];
      const max = Math.max(...values, 1);
      const innerWidth = this.width - PAD * 2;
      const innerHeight = this.height - PAD * 2;
      const step = values.length > 1 ? innerWidth / (values.length - 1) : 0;
      return values.map((value, index) => ({
        x: round1(values.length > 1 ? PAD + index * step : this.width / 2),
        y: round1(PAD + innerHeight - (value / max) * innerHeight),
      }));
    },
    // Up to the start of the current bucket…
    history() {
      const points = this.points.slice(0, -1);
      if (points.length < 2) return '';
      return points.map((point, index) => `${index ? 'L' : 'M'}${point.x} ${point.y}`).join(' ');
    },
    // …and the current bucket itself.
    current() {
      if (this.points.length < 2) return '';
      const [from, to] = this.points.slice(-2);
      return `M${from.x} ${from.y} L${to.x} ${to.y}`;
    },
    last() {
      return this.points.length ? this.points[this.points.length - 1] : null;
    },
  },
};
</script>
<style scoped>
.spark {
  display: block;
  flex: none;
  overflow: visible;
}

/* A ring in the surface colour keeps the dot legible on its own line. */
.spark__dot {
  stroke: var(--color-bg-canvas);
  stroke-width: 2;
}
</style>
